<template>
    <TableLayout :permissions="['business:retention:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="姓名/手机号" prop="keyWords">
                <el-input v-model="searchForm.keyWords" placeholder="请输入姓名/手机号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="公司/部门名称" prop="companyName">
                <el-input v-model="searchForm.companyName" placeholder="请输入公司/部门名称" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="人员类型" prop="type">
                <el-select v-model="searchForm.type" placeholder="请选择">
                    <el-option label="劳务访客" value="0"></el-option>
                    <el-option label="普通访客" value="1"></el-option>
                    <el-option label="内部员工" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="起始时间" prop="startTime">
                <el-date-picker
                    @change="seleTime"
                    v-model="time"
                    type="datetimerange"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <ul class="toolbar" v-permissions="['business:retention:exportExcel']">
                <li><el-button type="primary" :loading="isWorking.export" v-permissions="['business:retention:exportExcel']" @click="exportExcel">导出</el-button></li>
            </ul>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="companyName" label="公司/组织" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.type === 2 || row.type === 0">{{row.companyName}}</span>
                        <span v-else>{{row.visitCompanyName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="人员类型" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.type === 0">劳务访客</span>
                        <span v-if="row.type === 1">普通访客</span>
                        <span v-if="row.type === 2">内部员工</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="姓名" min-width="100px"></el-table-column>
                <el-table-column prop="phone" label="手机号" min-width="100px"></el-table-column>
                <el-table-column prop="idcardDecode" label="身份证号" min-width="130px"></el-table-column>
                <el-table-column label="进场门禁" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.type === 1">-</span>
                        <span v-else>{{row.deviceName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="eventDate" label="进场时间" min-width="100px"></el-table-column>
                <el-table-column label="人脸照片" min-width="100px">
                  <template slot-scope="{row}">
                    <el-image v-if="row.faceImgFull!=null"
                              style="width: 80px; height: 80px"
                              :src="row.faceImgFull"
                              :preview-src-list="[row.faceImgFull]">
                    </el-image>
                  </template>
                </el-table-column>
              <el-table-column
                  label="操作"
                  min-width="120"
                  fixed="right"
              >
                <template slot-scope="{row}">
                  <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:retention:delete']">标记离场</el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
export default {
  name: 'Retention',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      // 搜索
      searchForm: {
        companyName: '',
        type: '',
        keyWords: '',
        startTime: '',
        endTime: ''
      },
      time: []
    }
  },
  created () {
    this.config({
      module: '在厂人员信息 表（滞留）',
      api: '/business/retention',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    reset () {
      this.$refs.searchForm.resetFields()
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.time = []
      this.search()
    },
    seleTime (e) {
      this.searchForm.startTime = e[0]
      this.searchForm.endTime = e[1]
    }
  }
}
</script>
